import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, createVNode as _createVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-101620d7"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["disabled"]

import BaseTypography from '@/components/common/BaseTypography.vue';
import { withDefaults, computed } from 'vue';
import type { TypographyType } from '@/types/Base/TypographyType';

import { useWindowSize } from '@vueuse/core';


export default /*#__PURE__*/_defineComponent({
  __name: 'BaseButton',
  props: {
    text: {},
    type: {},
    color: { default: '#fff' },
    paddingX: { default: 'auto' },
    paddingY: { default: 'auto' },
    ui: {},
    disabled: { type: Boolean, default: false }
  },
  setup(__props: any) {

const { width } = useWindowSize();

const props = __props;

const uiClass = computed(() => `base-btn-ui-${props.ui}`);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    class: _normalizeClass([
            uiClass.value,
            {
                'base-btn-mobile': _unref(width) < 1024,
                'base-btn': _unref(width) > 1024,
            },
        ]),
    style: _normalizeStyle({ padding: `${_ctx.paddingY}px ${_ctx.paddingX}px` }),
    disabled: _ctx.disabled
  }, [
    (_ctx.$slots.default || _ctx.text)
      ? _renderSlot(_ctx.$slots, "default", { key: 0 }, () => [
          _createVNode(BaseTypography, {
            text: _ctx.text,
            type: _ctx.type,
            color: _ctx.color,
            tag: "span"
          }, null, 8, ["text", "type", "color"])
        ])
      : _createCommentVNode("", true),
    _renderSlot(_ctx.$slots, "end")
  ], 14, _hoisted_1))
}
}

})